import { PlayerAhoyEvent } from '../../player_ahoy_event';
import nodelistToArray from '../../utils/nodelist_to_array';

export default class SubtitleList {
  constructor(player, options = {}){
    this.options_ = options;
    this.player = player;
    this._el = document.createElement("div");
    this._el.className = "vjs-subtitle-switcher__container";
  }

  videoId() {
    return this.options_.videoId;
  }

  play_uuid() {
    return this.options_.play_uuid;
  }

  textTracks() {
    return nodelistToArray(this.player.textTracks()).filter((track) => {
      return !this.isMetadata(track);
    });
  }

  createList() {
    const ul = document.createElement("ul");
    ul.setAttribute('role', 'menu');
    ul.classList.add("vjs-subtitle-switcher__list");
    return ul;
  }

  createListItem(representation){
    const el = document.createElement("li");
    el.setAttribute('role', 'menuitem');
    el.setAttribute('tabindex', '0');
    const label = representation.label.toLowerCase();
    const className = `vjs-subtitle-switcher__list-item ${label} ${label === 'indonesian' ? 'is-active' : ''}`;
    const action = () => {
      this.changeSubtitle(representation);
      this.removeActiveClass();
      this.setActiveClass(representation);
    };

    el.innerText = representation.label;
    el.textContent = representation.label;
    el.className = className;
    el.onclick = action;
    el.ontouchend = action;

    return el;
  }

  changeSubtitle(representation) {
    this.textTracks().forEach((track) => {
      if (track == representation) {
        track.mode = 'showing';
        this.triggerEventChange(track.label.toLowerCase());
        PlayerAhoyEvent.sendSubtitle({
          action: 'select',
          subtitle: track.label,
          video_id: this.videoId(),
          play_uuid: this.play_uuid()
        });
      } else {
        track.mode = 'hidden';
      }
    });
  }

  removeActiveClass() {
    const arrElements = nodelistToArray(document.querySelectorAll(".vjs-subtitle-switcher__list-item"));
    arrElements.forEach((el) => {
      el.classList.remove('is-active');
    });
  }

  setActiveClass(representation) {
    const language = (representation.label || 'off').toLowerCase();
    const el = document.querySelector(`.vjs-subtitle-switcher__list-item.${language}`);
    el.classList.add("is-active");
  }

  createOffButton() {
    const el = document.createElement("li");
    el.setAttribute('role', 'menuitem');
    el.setAttribute('tabindex', '0');
    const action = () => {
      this.removeActiveClass();
      this.setActiveClass({ language: 'off' });
      this.triggerEventChange("off");

      this.textTracks().forEach((track) => {
        track.mode = 'hidden';
      });
    };

    el.textContent = "Off";
    el.innerText = "Off";
    el.className = 'vjs-subtitle-switcher__list-item off';
    el.onclick = action;
    el.ontouchend = action;

    return el;
  }

  el(){
    return this._el;
  }

  setEl(){
    var ul = this.createList();
    this.textTracks().forEach((track) => {
      if (track.kind == "captions") {
        var listItem = this.createListItem(track);
        ul.appendChild(listItem);
      }
    });
    var offButton = this.createOffButton();
    ul.appendChild(offButton);
    this.el().appendChild(ul);
    this.bindFocusOut();
  }

  show(){
    this.el().style.display = "block";
    this.el().querySelector('ul li').focus();
    this.checkPlayerInactive();
  }

  hide(){
    this.el().style.display = "none";
  }

  hideIfOutside(e){
    if (!document.querySelector('.vjs-subtitle-switcher').contains(e.target)) {
      this.hide();
    }
  }

  bindFocusOut(){
    document.addEventListener('click', this.hideIfOutside.bind(this));
    this.player.on('vp-episodes-list-open', this.hide.bind(this));
  }

  displayStatus(){
    return getComputedStyle(this.el()).display;
  }

  toggle(){
    if (this.displayStatus() == "none") {
      this.show();
      this.triggerEventClick();
    } else {
      this.hide();
    }
  }

  checkPlayerInactive() {
    const element = document.querySelector('.video-js');
    const controlBar = document.querySelector('.vjs-progress-control');

    const interval = setInterval(() => {
      if (element.classList.contains('vjs-user-inactive') && !element.classList.contains('vjs-paused')) {
        clearInterval(interval);
        controlBar.classList.remove('vjs-progress-control--hidden');
        this.hide();
      }
    }, 100);
  }

  isMetadata(track) {
    return track.label == 'segment-metadata';
  }

  triggerEventChange(selectedTrack){ 
    this.player.trigger({type: "vp-subtitle-change", id: this.options_.videoId, track: selectedTrack});
  }

  triggerEventClick(){
    this.player.trigger({type: "vp-subtitle-click", id: this.options_.videoId});
  }
}
